module.exports = __webpack_public_path__ + "img/keyword-install.bd0629b6.png";